import React, { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';
import URI from 'urijs';
import { useAppContext } from 'Context/ReactAppContext';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { goToHash } from 'Components/utils/scroll/scrollToHash';
import { usePrevious } from 'Src/hooks/use-previous/usePrevious';
import { endLoading, startLoading } from 'Store/global-loader/globalLoader.action';
import { unsetEntryRoute } from 'Store/booking/entry-route/entryroute.action';
import { redirectToOidc } from 'Utils/uri/redirectUtils';
import { SYNC_WITH_LOCATION } from 'Store/constants';
export const RouteChangeListener = () => {
  const router = useRouter();
  const hasNavigated = useRef(false);
  const dispatch = useDispatch();
  const uri = new URI(router.asPath);
  const pathname = uri.pathname();
  const previousPathname = usePrevious(pathname);
  const { isDesktop } = useResponsive();
  const appContext = useAppContext();
  const scrollUnderNav = !isDesktop;
  const isSeller =
    appContext.isSeller || // the pdf can be accessed by anybody but is only used by seller
    pathname.startsWith('/proposal-pdf');
  useEffect(() => {
    if (isSeller) {
      if (router.query?.forceAuth !== undefined) {
        return redirectToOidc(appContext);
      }
    }
  }, []);
  useEffect(() => {
    if (uri.hash()) {
      goToHash(uri.hash(), scrollUnderNav);
    } else if (hasNavigated.current) {
      window.scrollTo(0, 0);
    }
  }, [pathname, uri.hash()]);
  useEffect(() => {
    const showLoader = (nextUri, { shallow }) => {
      // on the booking engine there is no loader between pages, no loader also if it is the same path
      if (!shallow) {
        hasNavigated.current = true;
      }

      if (
        !shallow &&
        !(nextUri.startsWith('/booking/') && previousPathname.startsWith('/booking/'))
      ) {
        if (!nextUri.startsWith('/booking/') && !nextUri.startsWith('/option/')) {
          dispatch(unsetEntryRoute());
        }

        // startLoading second arg it here to handle scroll correctly after navigation
        // see Components/widgets/loading/Loading.jsx
        dispatch(startLoading('', true));
      }
    };

    const hideLoader = (nextUri, { shallow }) => {
      // By default next triggers routeChangeComplete even on the first app mount
      // However, in the BookingEngine we show a loader while the content loads
      const queryParams = URI.parseQuery(new URI(nextUri).query());
      dispatch({
        type: SYNC_WITH_LOCATION,
        payload: {
          location: {
            queryParams,
          },
        },
      });

      if (
        !shallow &&
        hasNavigated.current &&
        !(nextUri.startsWith('/booking/') && previousPathname.startsWith('/booking/'))
      ) {
        dispatch(endLoading());
      }
    };

    // Show the loader before each page transition, hide after
    router.events.on('routeChangeStart', showLoader);
    router.events.on('routeChangeComplete', hideLoader);
    return () => {
      router.events.off('routeChangeStart', showLoader);
      router.events.off('routeChangeComplete', hideLoader);
    };
  }, []);
  return null;
};
